import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

const AboutDeals: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="81"
    height="80"
    fill="none"
    viewBox="0 0 81 80"
  >
    <path
      fill={colors['--pink-500']}
      d="M28.492 24.12a.5.5 0 00-.5.5v6.329a.5.5 0 00.5.5H56.81a.5.5 0 00.5-.5v-6.33a.5.5 0 00-.5-.5H28.49zm26.375 4.386a.5.5 0 01-.5.5H41.846a.5.5 0 01-.5-.5v-1.444a.5.5 0 01.5-.5h12.523a.5.5 0 01.5.5v1.444zM28.492 36.335a.5.5 0 00-.5.5v6.33a.5.5 0 00.5.5H56.81a.5.5 0 00.5-.5v-6.33a.5.5 0 00-.5-.5H28.49zm26.375 4.386a.5.5 0 01-.5.5h-8.772a.5.5 0 01-.5-.5v-1.443a.5.5 0 01.5-.5h8.773a.5.5 0 01.5.5v1.444zM28.492 48.552a.5.5 0 00-.5.5v6.33a.5.5 0 00.5.5H56.81a.5.5 0 00.5-.5v-6.33a.5.5 0 00-.5-.5H28.49zm26.375 4.387a.5.5 0 01-.5.5H37.335a.5.5 0 01-.5-.5v-1.444a.5.5 0 01.5-.5h17.032a.5.5 0 01.5.5v1.444z"
    />
    <path
      fill={colors['--pink-500']}
      d="M23.238 62.286V17.714h36.19v44.572h-36.19zM21.428 66h39.81c.48 0 .94-.196 1.28-.544.339-.348.53-.82.53-1.313V15.857c0-.492-.191-.965-.53-1.313-.34-.348-.8-.544-1.28-.544h-39.81c-.48 0-.94.196-1.279.544-.34.348-.53.82-.53 1.313v48.286c0 .492.19.965.53 1.313s.8.544 1.28.544z"
    />
    <path
      fill={colors['--pink-500']}
      d="M17.81 58.571h7.238c1.206 0 1.81-.619 1.81-1.857s-.604-1.857-1.81-1.857H17.81c-1.207 0-1.81.62-1.81 1.857 0 1.238.603 1.857 1.81 1.857zm0-11.143h7.238c1.206 0 1.81-.619 1.81-1.857s-.604-1.857-1.81-1.857H17.81c-1.207 0-1.81.62-1.81 1.857 0 1.238.603 1.857 1.81 1.857zm0-11.142h7.238c1.206 0 1.81-.62 1.81-1.858s-.604-1.857-1.81-1.857H17.81c-1.207 0-1.81.62-1.81 1.857 0 1.239.603 1.858 1.81 1.858zm0-11.143h7.238c1.206 0 1.81-.62 1.81-1.857 0-1.239-.604-1.858-1.81-1.858H17.81c-1.207 0-1.81.62-1.81 1.858s.603 1.857 1.81 1.857z"
    />
    <path stroke={colors['--pink-500']} strokeWidth="3" d="M1.5 1.5H78.743V78.5H1.5z" />
  </svg>
);

export default AboutDeals;
